var exports = {
  "VN": "xaf9ae18d--8c6708--close",
  "Qs": "xaf9ae18d--8c6708--content",
  "_8": "xaf9ae18d--8c6708--img",
  "nf": "xaf9ae18d--8c6708--link",
};

module.exports = exports;
